import React from 'react';
import styles from './ConfirmationDialog.module.css';
import classnames from 'classnames';
import { FloComponentProps } from 'components';
import { FloModal } from 'components/FloModal';
import { FloButton, FloButtonType } from 'components/FloButton';
import { useTranslation } from 'react-i18next';

type ConfirmationDialogMetadata = { [key: string]: any };

interface ConfirmationDialogProps extends FloComponentProps {
  show:                         boolean;
  confirmationDialogMetadata:   ConfirmationDialogMetadata;
  onHide:                       () => void;
  title:                        string;
  description:                  string | React.ReactNode;
  actionText?:                  string;
  onAccept:                     (confirmationDialogMetadata: ConfirmationDialogMetadata) => void;
  onCancel?:                    () => void;
}

export const ConfirmationDialog: React.FC<ConfirmationDialogProps> =  React.memo(({
  className,
  title,
  description,
  name = 'confirmation-dialog-name',
  onAccept,
  onCancel = (confirmationDialogMetadata: ConfirmationDialogMetadata) => {},
  actionText = 'Confirm',
  onHide,
  confirmationDialogMetadata,
  ...rest
  }) => {

  const { t } = useTranslation('flo-components');

  return (
    <>
      <FloModal
        {...rest}
        name           = {name}
        onHide         = {() => {
          onCancel(confirmationDialogMetadata);
          onHide();
        }}
        className      = {classnames(className, styles.root)}
        title          = {title}
        body           = { (props) => (<span>{description}</span>)}
        footer         = { (props) => {
          return (
            <>
              <FloButton
                text       = {t('Cancel')}
                type       = {FloButtonType.SECONDARY}
                onClick    = {() => {
                  onCancel(confirmationDialogMetadata);
                  onHide();
                }}
              />
              <FloButton
                text       = {t(actionText)}
                onClick    = {() => {
                  onAccept(confirmationDialogMetadata);
                  onHide();
                }}
              />
            </>
          )
        }}
      />
    </>
  );
});

export default ConfirmationDialog;
